import styled from "styled-components";
import { theme } from "../../constants/theme";

// Pill-style wrapper for the email input. Mirrors AddressPillWrap from
// the landing page so the envelope icon sits inside the input pill next
// to the placeholder, instead of stacked above it as a separate label.
export const EmailPillWrap = styled.div`
  width: 100%;
  margin: 0 auto;

  .form-group-no-border {
    background: ${theme.color.surface};
    border: 1.5px solid ${theme.color.border};
    border-radius: ${theme.radius.pill};
    box-shadow: ${theme.shadow.sm};
    padding: 0.35rem 0.75rem 0.35rem 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition:
      border-color ${theme.motion.base},
      box-shadow ${theme.motion.base},
      transform ${theme.motion.base};
  }

  .form-group-no-border:hover {
    border-color: ${theme.color.borderStrong};
  }

  .form-group-no-border:focus-within {
    border-color: ${theme.color.salmon};
    box-shadow: ${theme.shadow.sm}, ${theme.shadow.ring};
    transform: translateY(-1px);
  }

  .input-group-prepend {
    margin: 0;
  }

  .input-group-text {
    background: transparent;
    border: none;
    padding: 0 0.25rem 0 0;
    color: ${theme.color.slate};
    font-size: 1.05rem;
  }

  .form-control {
    flex: 1;
    width: 100%;
    border: none !important;
    background: transparent !important;
    padding: 0.65rem 0.5rem !important;
    font-size: 1rem !important;
    font-weight: ${theme.weight.medium} !important;
    color: ${theme.color.text} !important;
    box-shadow: none !important;
    outline: none !important;
  }

  .form-control::placeholder {
    color: ${theme.color.textSubtle} !important;
    font-weight: ${theme.weight.regular} !important;
    opacity: 1 !important;
  }
`;
